"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _date = require("@/utils/date");
var area = _interopRequireWildcard(require("@/api/area"));
var _RegionDialog = _interopRequireDefault(require("./components/RegionDialog.vue"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _RegionSortTable = _interopRequireDefault(require("./components/RegionSortTable.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RegionDialog: _RegionDialog.default,
    RegionSortTable: _RegionSortTable.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      listLoading: false,
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 50
      }
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    formatDateTime: function formatDateTime(n) {
      return (0, _date.formatDateTime)(n);
    },
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return area.findAll(this.listQuery);
            case 2:
              res = _context.sent;
              this.tableData = res.data.areas;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    handleEdit: function handleEdit(row) {
      this.$refs["dialog"].handleEdit(row);
    },
    handleAdd: function handleAdd() {
      this.$refs["dialog"].handleAdd();
    },
    handleSort: function handleSort() {
      this.$refs["sortTable"].handleOpen(this.tableData);
    },
    handleDelete: function handleDelete(row) {
      var _this = this;
      this.$confirm("Khu vực này sẽ bị xóa, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        area.remove(row.id).then(function () {
          _this.$message({
            type: "success",
            message: "Xóa thành công"
          });
          _this.getTableData();
        });
      });
    },
    onActiveChange: function onActiveChange(row, isHighlight) {
      var _this2 = this;
      area.update(row.id, {
        area: {
          isHighlight: isHighlight
        }
      }).then(function () {
        _this2.$message.close();
        _this2.$message({
          type: "success",
          message: "Đã lưu thay đổi",
          duration: 600
        });
        _this2.getTableData();
      });
    }
  }
};